module.exports = __webpack_public_path__ + "static/media/facebook.b9e75e61.svg";